"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemMainInfo = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const PinDropOutlined_1 = __importDefault(require("@mui/icons-material/PinDropOutlined"));
const WatchLaterOutlined_1 = __importDefault(require("@mui/icons-material/WatchLaterOutlined"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const MainInfoWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 24px;
  transition: padding 0.4s linear;
  border-radius: 0 0 2px 2px;
  color: #212121;
  background-color: #ffffff;
`;
const MainInfoHeader = styled_components_1.default.h1 `
  margin-top: 0;
  font-weight: 700;
  color: #212121;
  font-size: 1.5rem;
`;
const MainInfoContent = styled_components_1.default.div `
  display: flex;
`;
const SecondaryCTAButton = styled_components_1.default.div `
  display: none;
  flex-basis: 50%;
  @media (min-width: 768px) {
    display: flex;
    justify-content: end;
    align-items: baseline;
  }
  button {
    width: 50%;
  }
`;
const SecondaryContent = styled_components_1.default.div `
  flex-basis: 100%;
  @media (min-width: 768px) {
    flex-basis: 50%;
  }
  ul {
    padding: 0 !important;
    li {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .place-name {
    .MuiListItemText-primary {
      color: ${props => props.theme.palette.mainAppColor.dark};
      text-transform: uppercase;
      font-weight: 700;
    }
  }
`;
const FewPacesLeftIndicator = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-top: 10px;
  .booking-circle {
    height: 10px;
    width: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 23px;
    margin-left: 7px;

    &.yellow {
      background-color: #ffcc00;
    }
  }
`;
const ItemMainInfo = (props) => {
    const { content, showBookingArea, location } = props;
    const { availability } = content.data;
    const isBookable = content.data.bookable && availability;
    const fewPlacesLeft = isBookable && availability.availabilityState && availability.availabilityState === 'few_places_left';
    const fewPlacesLeftText = availability && availability.textsForDisplay ? availability.textsForDisplay.availabilityState : i18n_js_1.default.t('book_now');
    const renderActivityTime = () => {
        const activityDate = new Date(content.data.start);
        const dayOfTheWeek = i18n_js_1.default.t('dictionary.dayNames')[activityDate.getDay()];
        const month = i18n_js_1.default.t('dictionary.monthNames')[activityDate.getMonth()];
        const startTime = helpers_1.Helpers.getHourFromDate(content.data.start, props.timezone);
        const endTime = helpers_1.Helpers.getHourFromDate(content.data.end, props.timezone);
        const datePart = `${dayOfTheWeek}, ${activityDate.getDate()}. ${month}`;
        if (content.data.showStartTime && content.data.showEndTime) {
            return `${datePart} • ${startTime} - ${endTime}`;
        }
        if (content.data.showStartTime && !content.data.showEndTime) {
            return `${datePart} • ${startTime}`;
        }
        return datePart;
    };
    return (react_1.default.createElement(MainInfoWrapper, null,
        react_1.default.createElement(MainInfoHeader, { id: "aqa_activity_title" }, content.data.title),
        react_1.default.createElement(MainInfoContent, null,
            react_1.default.createElement(SecondaryContent, null,
                react_1.default.createElement(material_1.List, null,
                    content.data.placeName && (react_1.default.createElement(react_router_dom_1.Link, { to: {
                            pathname: `${location.pathname}/map`,
                            search: location.search,
                        } },
                        react_1.default.createElement(material_1.ListItem, { className: "place-name" },
                            react_1.default.createElement(material_1.ListItemIcon, null,
                                react_1.default.createElement(PinDropOutlined_1.default, { htmlColor: "black" })),
                            react_1.default.createElement(material_1.ListItemText, { primary: content.data.placeName })))),
                    props.content.type === 'activity' && (react_1.default.createElement(material_1.ListItem, null,
                        react_1.default.createElement(material_1.ListItemIcon, null,
                            react_1.default.createElement(WatchLaterOutlined_1.default, { htmlColor: "black" })),
                        react_1.default.createElement(material_1.ListItemText, { id: "aqa_activity_date", primary: renderActivityTime() })))),
                fewPlacesLeft && (react_1.default.createElement(FewPacesLeftIndicator, null,
                    react_1.default.createElement("div", { className: "booking-circle yellow" }),
                    fewPlacesLeftText))),
            isBookable && (react_1.default.createElement(SecondaryCTAButton, null,
                react_1.default.createElement(material_1.Button, { variant: "contained", onClick: () => showBookingArea(), id: "aqa_activity_participate" }, availability.textsForDisplay.bookButton))))));
};
exports.ItemMainInfo = ItemMainInfo;
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ItemMainInfo));
